import {
  LOAD_USER_SITES_REQUEST,
  LOAD_USER_SITES_REQUEST_SUCCESS,
  LOAD_USER_SITES_REQUEST_FAIL,
  UPDATE_USER_SITES,
} from "./actionTypes";

const INITIAL_STATE = {
  projects: {},
  sites: {},
  isLoading: false,
  hasLoaded: false,
  projectGroups: [],
};

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case LOAD_USER_SITES_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
      };
    case LOAD_USER_SITES_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case LOAD_USER_SITES_REQUEST_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case UPDATE_USER_SITES:
      return {
        ...state,
        projects: action.projects,
        sites: action.sites,
        projectGroups: action.projectGroups,
        hasLoaded: true,
      };
    default:
      return state;
  }
}
